// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2JRfM","description":"PatientConsentPreview_description__2xkuX"};